const cleaner = require("deep-cleaner");
const pTimeout = require("p-timeout");

export default function(name, payload, callback) {
  const event = new Promise((resolve, reject) => {
    try {
      const params = cleaner(payload);
      window.clevertap.event.push(name, params);
      resolve();
    } catch (error) {
      reject(error);
    }
  });
  return pTimeout(event, 5000)
    .then(() => {
      if (typeof callback === "function") {
        callback();
      }
    })
    .catch(error => {
      console.error(error);
      if (typeof callback === "function") {
        callback();
      }
    });
}
